module.exports = __webpack_public_path__ + "static/media/flat-view-controls-selected-icon.cb4fe612.svg";